import styled from 'styled-components';

import { iconSize } from '@pkg/primitives';

export const StyledImageIcon = styled.img`
    //todo? - add size as prop?
    width: ${iconSize.medium}px;
    height: ${iconSize.medium}px;
`;
